import { MicroviewCommunicationChannel } from '@tableau/microview-communication-service';

export class SearchMicroViewBundleReadyChannel extends MicroviewCommunicationChannel<void, void> {
  public name: string = 'SearchMicroViewBundleReadyChannel';
  public namespace: string = 'SearchMicroView';
}

export class SearchMicroViewRenderChannel extends MicroviewCommunicationChannel<void, void> {
  public name: string = 'SearchMicroViewRenderChannel';
  public namespace: string = 'SearchMicroView';
}

export class SearchMicroViewDisposeChannel extends MicroviewCommunicationChannel<void, void> {
  public name: string = 'SearchMicroViewDisposeChannel';
  public namespace: string = 'SearchMicroView';
}
